module.exports = __webpack_public_path__ + "ac150833fe341fe2ba24f90308525d63.png";